import { Balancer } from './Balancer';
import { PushTelemetryData } from '../data/PushTelemetryData';

export default class SurveyFactory {
	static createBalancer() {
		return new Balancer();
	}
	static createTelemetryData() {
		return new PushTelemetryData();
	}
}
